import React, { useEffect, useState, Suspense, lazy } from 'react';
import Hero from './components/Hero';
import Knowledge from './components/Knowledge';
import Benefits from './components/Benefits';
// Lazy load components that are lower in the page
const Story = lazy(() => import('./components/Story'));
const HowItWorks = lazy(() => import('./components/HowItWorks'));
const Testimonials = lazy(() => import('./components/Testimonials'));
const FAQ = lazy(() => import('./components/FAQ'));
const CTASection = lazy(() => import('./components/CTASection'));
const Footer = lazy(() => import('./components/Footer'));
export function App() {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    // Simular precarga de componentes críticos
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  return <div className="font-sans bg-[#f8f9ff] text-[#2d3748] min-h-screen" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Knowledge data-id="element-3" />
        <Benefits data-id="element-4" />
        <Suspense fallback={<div className="h-64 flex items-center justify-center" data-id="element-6">
              <div className="animate-pulse flex flex-col items-center" data-id="element-7">
                <div className="w-12 h-12 rounded-full bg-[#8b5cf6]/30 mb-3" data-id="element-8"></div>
                <div className="text-[#8b5cf6]/70" data-id="element-9">Cargando...</div>
              </div>
            </div>} data-id="element-5">
          {isLoaded && <>
              <Story data-id="element-10" />
              <HowItWorks data-id="element-11" />
              <Testimonials data-id="element-12" />
              <CTASection data-id="element-13" />
              <FAQ data-id="element-14" />
            </>}
        </Suspense>
      </main>
      <Suspense fallback={<div className="h-24 flex items-center justify-center text-gray-400" data-id="element-16">
            Cargando...
          </div>} data-id="element-15">
        {isLoaded && <Footer data-id="element-17" />}
      </Suspense>
    </div>;
}